import { get, post, put, del } from "../request";

/** 分页查询角色列表 */
export function roleList(params) {
  return get("/education-system/role/list", params);
}

/** 新增角色 */
export function roleSave(params) {
  return post("/education-system/role", params);
}

/** 修改角色 */
export function roleUpdate(params) {
  return put("/education-system/role", params);
}

/** 查询角色详情 */
export function roleInfo(id) {
  return get(`/education-system/role/${id}`);
}

/** 删除角色 */
export function roleDelete(id) {
  return del(`/education-system/role/${id}`);
}

/** 查询角色菜单权限树 */
export function RoleRightTree(id) {
  return get(`/education-system/menu/roleMenuTreeselect/${id}`);
}

/** 保存角色菜单权限 */
export function RoleRightSave(params) {
  return put("/education-system/role", params);
}



// WEBPACK FOOTER //
// ./src/api/system/role.js